var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "App" } },
    [
      _c(
        "el-form",
        { ref: "ruleForm", attrs: { size: "small" } },
        [
          _c(
            "el-form-item",
            { staticStyle: { "text-align": "center" } },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onRecord } },
                [_vm._v("视频录制")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticStyle: { "z-index": "3000" },
          attrs: {
            title: "视频录制",
            width: "50%",
            visible: _vm.dialogVisible,
            modal: false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c("video", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading"
              }
            ],
            ref: "video",
            staticStyle: { width: "100%" },
            attrs: { controls: "", autoplay: "", playsinline: "" }
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.onCancel } },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    disabled: _vm.recorder == null,
                    icon: "el-icon-refresh-left",
                    size: "small",
                    type: "primary"
                  },
                  on: { click: _vm.onReset }
                },
                [_vm._v("重新录制")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    disabled: _vm.videoStart,
                    icon: "el-icon-video-camera-solid",
                    size: "small",
                    type: "primary"
                  },
                  on: { click: _vm.onStart }
                },
                [_vm._v("开始录制")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    disabled: !_vm.videoStart,
                    icon: "el-icon-remove",
                    size: "small",
                    type: "primary"
                  },
                  on: { click: _vm.onStop }
                },
                [_vm._v("停止录制")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    icon: "el-icon-remove",
                    size: "small",
                    type: "primary"
                  },
                  on: { click: _vm.onPlay }
                },
                [_vm._v("回放视频")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "success" },
                  on: { click: _vm.onSave }
                },
                [_vm._v("提交")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }